import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';

export const REQUEST_DATE_FORMAT = 'y-MM-dd';

export const formatForRequest = (date: Date | number): string => {
  return format(date, REQUEST_DATE_FORMAT);
};

export const parseFromRequestFormat = (date: string): Date => {
  return parse(date, REQUEST_DATE_FORMAT, new Date());
};
